import { ModelRow } from "@mcleod/core";
import { DataSourceMode } from "@mcleod/components";
import { AutogenLayoutAddStopCompareItems } from "./autogen/AutogenLayoutAddStopCompareItems";

export class AddStopCompareItems extends AutogenLayoutAddStopCompareItems {

    private _compareItems: ModelRow[];
    private _key: string;

    override onLoad(): void | Promise<void> {
        this.tableCompareItems.dataSource = this.sourceEdiCompareItem;
    }

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
        const newTable = this.filterTable();
        if (newTable != null) {
            if (newTable.length == 0) {
                this.tableCompareItems.visible = false;
            } else {
                this.tableCompareItems.dataSource.setRowsAndMode(DataSourceMode.NONE, newTable);
            }
        }
    }

    private filterTable(): ModelRow[] {
        let newTable = [];
        if (this._compareItems?.length > 0) {
            const changeType = this._compareItems[0].get("change_type");
            if (changeType == "NS") {
                newTable = this._compareItems.filter(value => {
                    const sourceValue = value.get("source_value");
                    if (sourceValue !== null && sourceValue !== "" && sourceValue !== undefined) {
                        return value;
                    }
                });
            }
            else {
                newTable = this._compareItems;
            }
        } else {
            newTable = this._compareItems;
        }
        return newTable;
    }

}
